import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// components
import { Col } from '../../foundations/Grid';

export const ColStyledHeading = styled(Col)`
  ${({ index }) => {
    return css`
      padding-top: ${index > 0 ? rem(24) : 0};
    `;
  }}
`;

export const ColStyledTeamMember = styled(Col)`
  ${({ detailsModalId, theme }) => {
    let thisPaddingRight = 0;
    const smallUp = theme.smallUp();
    const custom580767 = theme.custom580767();
    const xlargeUp = theme.xlargeUp();

    if (xlargeUp) {
      thisPaddingRight = rem(20);
    } else if (smallUp) {
      thisPaddingRight = rem(10);
    }

    return css`
      padding-right: ${thisPaddingRight};
      padding-bottom: ${rem(16)};
      text-align: center;
      ${custom580767
      && css`
        max-width: calc(100% / 3);
        flex: 0 calc(100% / 3);
      `}

      /** ensure the modal button is full width of container when the photo is absent */
      .${detailsModalId}-open-modal-button {
        width: 100%;
        max-width: 100%;
        &:hover {
          .nmx-icon {
            display: block;
            .icon-fill {
              fill: ${theme.colors.action.lightTheme.utilityItemHover};
            }
          }
        }
        .aura-agent-photo {
          margin-bottom: ${rem(16)};
        }
      }
    `;
  }}
`;

export const SpanStyledAgent = styled.span`
  position: relative;
  width: 100%;
`;

export const SpanStyledIcon = styled.span`
  ${({ theme }) => {
    return css`
      display: inline-flex;
      position: absolute;
      top: 0; /** needed for initials scenario placement */
      right: 0;
      padding-top: ${rem(5)};
      padding-right: ${rem(5)};
      justify-content: flex-end;
      z-index: 1;
      .nmx-icon {
        display: none;
        width: ${rem(20)};
        height: ${rem(20)};
        background: ${theme.colors.action.darkTheme.utilityItemDefault};
        border: ${rem(1)} solid ${theme.colors.action.darkTheme.utilityItemDefault}; /** allows for higher accessibility/visibility on light backgrounds */
        .icon-fill {
          fill: ${theme.colors.action.lightTheme.utilityItemDefault};
        }
      }
    `;
  }}
`;
